import { Client, FishingTrip } from '../../types';

export const getStats = (clients: Client[], trips: FishingTrip[]) => {
  return { 
    totalClients: clients.length, 
    totalLeads: 0, 
    activeTrips: trips.length, 
    speciesCount: {}, 
    topTrophies: [], 
    pipeline: { budget: 0, preReserved: 0, confirmed: 0 } 
  };
};
